
import { defineComponent } from 'vue'
import TextLinkWithArrow from '@/components/molecules/TextLinkWithArrow.vue'

export default defineComponent({
  components: {
    TextLinkWithArrow
  }
})
